const mapState2 = function (list) {
	let tmp = null;
	if (typeof uni != 'undefined') tmp = uni;
	else if (typeof window != 'undefined') tmp = window;
	//if (!tmp.store) throw 'vue的store未引出';

	let retlist = {};
	list.forEach(name => {
		retlist[name] = {
			get() {
				return tmp.store.state[name];
			},
			set(value) {
				//'setobj', 'setarr', 'setvalue', 
				//'setobjarr', 'setobjvalue', 'setobjobj', 'cleararr', 'clearobjarr'
				if (typeof value == 'object') {
					if (Array.isArray(value)) {
						tmp.store.commit('cleararr', { n: name });
						tmp.store.commit('setarr', { n: name, v: value });
					} else if (value instanceof Date) {
						tmp.store.commit('setvalue', { n: name, v: value });
					} else {
						tmp.store.commit('setobj', { n: name, v: value });
					}
				} else {
					tmp.store.commit('setvalue', { n: name, v: value });
				}
			},
		}
	});
	return retlist;
};


import { mapState, mapMutations, mapActions } from "vuex";

export {
	mapState,
	mapMutations,
	mapActions,
	mapState2,
}